import React from 'react'

import { RiDeleteBinLine } from 'react-icons/ri'

import { Table, Button } from '_zari/core'

import { ZrSwal } from 'utils'

const EliminarCell = ({ row, dispatch }) => {
  const clickEliminar = React.useCallback(() => {
    ZrSwal.showAlert({
      tipo: 'error',
      mensaje: 'Seguro de eliminar el registro?',
      showCerrar: true,
      onSuccess: () => {
        dispatch({
          type: 'eliminar',
          payload: row
        })
      }
    })
  }, [row, dispatch])

  return (
    <Table.Cell>
      <Button tiny color='danger' onClick={clickEliminar}>
        <RiDeleteBinLine />
      </Button>
    </Table.Cell>
  )
}

export default React.memo(EliminarCell)
